import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_FINANCIAL_PRODUCTS_QUERY = gql`
  query pagedFinancialProducts($pager: PagerInputNew, $filters: FilterInput) {
    pagedFinancialProducts(pager: $pager, filters: $filters) {
      total
      values {
        ...financialProduct
      }
    }
  }
  ${Fragments.financialProduct}
`;

export const CONTRACT_TYPES_DICTIONARY_QUERY = gql`
  query contractTypesDictionary {
    contractTypesDictionary {
      contractTypeId
      contractTypeName
    }
  }
`;

export const STATE_HISTORY_QUERY = gql`
  query financialProductStateHistory($productId: Int!) {
    financialProductStateHistory(productId: $productId) {
      transitionId
      stateName
      transitionMoment
      userName
    }
  }
`;
